import React from 'react';
import './Header.css';

function Header({ title, subtitle }) {
  return (
    <header className="header">
      <div className="header-content">
        <h1 className="header-title">{title || 'Document Inference'}</h1>
        <span className="header-subtitle">{subtitle || 'Extraccion de datos de facturas'}</span>
      </div>
    </header>
  );
}

export default Header;
